module.exports = __webpack_public_path__ + "static/media/language.cc6945b1.svg";